import { Injectable } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AlgoStrategyPromiseLookupService } from "shared/cubiq-services";
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as xml2js from "xml2js";
////////////////////////////////
import { ATDLUtilityService } from "./atdl-utility.service";
///
import { ATDLDataModel } from "../../data-atdl/model/atdl-data.model";
// paramter model
import { ATDLParameterDataModel } from "../../data-atdl/model/atdl-parameter-data.model";
import { ATDLEnumModel } from "../../data-atdl/model/atdl-enum.model";
// interface models
import { ATDLInterfaceLayoutModel } from "../../data-atdl/model/atdl-interface-layout.model";
import { ATDLInterfaceControlModel } from "../../data-atdl/model/atdl-interface-control.model";
// validation models
import { ATDLValidationCaseModel } from "../../data-atdl/model/atdl-validation-case.model";
import { ATDLValidationRuleModel } from "../../data-atdl/model/atdl-validation-rule.model";
import { ATDLValidationGroupModel } from "../../data-atdl/model/atdl-validation-group.model";
import { ATDLInterfaceDependencyModel } from "../../data-atdl/model/atdl-interface-dependency.model";
import { ATDLInterfaceAuxiliaryModel } from "../../data-atdl/model/atdl-interface-auxiliary.model";
// ENUMS
import { ATDLNOrientation } from "../../data-atdl/enums/atdl-orientation.enum";
import { ATDLDatasetService } from "./atdl-dataset.service";
import { ATDLNParameterType } from "../../data-atdl/enums/atdl-parameter-type.enum";
import { ATDLNControlType } from "../../data-atdl/enums/atdl-control-type.enum";
import { OELoggerService } from "../basic/oe-logger.service";

@Injectable()
export class ATDLParserService {
  /**********************************************************************/
  /* DATA  */
  private tempAuxiliaryControl: any = null; // temporary

  /**********************************************************************/
  /* CONSTRUCTOR  */

  constructor(
    protected oeLogger: OELoggerService,
    private algoLookup: AlgoStrategyPromiseLookupService,
    private atdlDataset: ATDLDatasetService,
    private atdlUtility: ATDLUtilityService,
  ) {
    this.oeLogger = oeLogger.for(__dirname);
  }

  /**********************************************************************/
  /* MAIN LOOP  */

  public initializeAlgoDefinitions(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.algoLookup.isPrimed().then(() => {
        this.outputExtendedLogging(`ALGO: Lookup -> Primed`);
        this.algoLookup.getAll().then((atdlDefinitions: Array<CubiqTS.AlgoStrategyImpl>) => {
          let success: boolean = true;
          if (atdlDefinitions != null && atdlDefinitions.length > 0) {
            for (let algoImplModel of atdlDefinitions) {
              try {
                if (algoImplModel instanceof CubiqTS.AlgoStrategyImpl) {
                  this.outputExtendedLogging(
                    `----------------------------------------------------`,
                  );
                  this.outputExtendedLogging(`ALGO: Lookup -> getItem(): id = ${algoImplModel.id}`);

                  if (
                    typeof algoImplModel.adtlDefinition === "string" &&
                    algoImplModel.adtlDefinition.length > 100
                  ) {
                    xml2js.parseString(
                      algoImplModel.adtlDefinition,
                      { explicitArray: false },
                      (error, algoObjectModel) => {
                        if (error) {
                          this.outputExtendedLogging(
                            `ERROR: atdlParser.initializeAlgoDefinitions(): Parsing error ${error}`,
                          );
                          logger.out.error(
                            `ALGO-STRATEGY: '${algoImplModel.id}' => ERROR: Parsing error ${error}`,
                          );
                        } else {
                          this.outputExtendedLogging(
                            `ALGO: xml2jsParser -> RESULT: `,
                            algoObjectModel,
                          );

                          let model: ATDLDataModel = this.parseAlgoDefinition(algoObjectModel);
                          this.outputExtendedLogging(
                            `ALGO: definitionParser -> PARSING RESULT: `,
                            model,
                          );

                          if (model != null) {
                            logger.out.info(
                              `ALGO-STRATEGY [SUCCESS]: '${algoImplModel.id}' => Loaded and parsed successfully.`,
                            );

                            model.id = algoImplModel.id;
                            model.description = algoImplModel.description;
                            this.atdlDataset.add(algoImplModel.id, model);
                          } else {
                            this.atdlDataset.recordInvalidAlgo(algoImplModel.id);
                            logger.out.error(
                              `ALGO-STRATEGY [ERROR]: '${algoImplModel.id}' => FAILED to parse.`,
                            );
                          }
                        }
                      },
                    );
                  } else {
                    logger.out.warn(
                      `ALGO-STRATEGY [ERROR]: '${algoImplModel.id}' => ATDL NOT FOUND or INVALID`,
                    );
                    this.outputExtendedLogging(
                      `ERROR: atdlParser.initializeAlgoDefinitions(): INVALID ATDL for '${algoImplModel.id}'`,
                    );
                    this.atdlDataset.recordInvalidAlgo(algoImplModel.id);
                  }
                } else {
                  logger.out.error(
                    `ERROR: atdlParser.initializeAlgoDefinitions(): Algo Strategy Definition INVALID!`,
                  );
                }
              } catch (e) {
                logger.out.error(
                  `ERROR: atdlParser.initializeAlgoDefinitions(): Error parsing ATDL defnition for Algo Id '${algoImplModel.id}'! Exception: ${e.toString()}`,
                );
              }
            }
          } else {
            logger.out.warn(
              `ERROR: atdlParser.initializeAlgoDefinitions(): No Algo Strategy Definitions!`,
            );
          }
          // Regardless of whether there are definitions, still mark the ATDL dataset as primed
          this.atdlDataset.setPrimed();
          resolve(success);
        });
      });
    });
  }

  /**
   * Where we want to create a dynamic ATDL model without adding it to the system. This
   * will be be user for ATDL designer
   *
   * @param atdlStr
   * @returns
   */
  public parseExternalATDL(atdlStr: string): Promise<ATDLDataModel> {
    return new Promise((resolve, reject) => {
      xml2js.parseString(atdlStr, { explicitArray: false }, (error, algoObjectModel) => {
        if (error) {
          reject(`ERROR: atdlParser.initializeAlgoDefinitions(): Parsing error ${error}`);
        } else {
          let model: ATDLDataModel = this.parseAlgoDefinition(algoObjectModel);
          this.outputExtendedLogging(`ALGO: definitionParser -> PARSING RESULT: `, model);
          if (model != null) {
            resolve(model);
          } else {
            reject("Failed to parse");
          }
        }
      });
    });
  }

  /**********************************************************************/
  /* PARSING - ALGO STRATEGY LEVEL */

  private parseAlgoDefinition(algoDefinition: any): ATDLDataModel {
    if (algoDefinition != null) {
      let model = new ATDLDataModel();
      this.tempAuxiliaryControl = new Array<any>();
      //
      let sourceData = algoDefinition.Strategies.Strategy;
      if (sourceData != null && sourceData.hasOwnProperty("$")) {
        /*********************/
        /* GENERAL */
        let generalData: any = sourceData.$;
        if (generalData != null && generalData.hasOwnProperty("name")) {
          model.name = generalData.name;
          model.uiRep = generalData.uiRep;
          model.version = generalData.version;
          model.wireValue = generalData.wireValue;
        } else {
          logger.out.error(`ERROR: atdlParser.parseAlgoDefinition(): General data source INVALID`);
          return null;
        }
        /*********************/
        /* PARAMETERS */
        let parametersData: any = sourceData.Parameter;
        if (
          parametersData != null &&
          parametersData instanceof Array &&
          parametersData.length > 0
        ) {
          model.parameters = new Array<ATDLParameterDataModel>();
          try {
            this.parseParameters(parametersData, model.parameters);
          } catch (ex) {
            logger.out.error(
              `ERROR: atdlParser.parseAlgoDefinition(): Parameter data parsing exception: %O`,
              ex,
            );
            return null;
          }
        } else if (
          parametersData != null &&
          parametersData.hasOwnProperty("$") &&
          parametersData.$.hasOwnProperty("name") &&
          parametersData.$.name.length > 0
        ) {
          model.parameters = new Array<ATDLParameterDataModel>();
          try {
            this.parseParameters([parametersData], model.parameters);
          } catch (ex) {
            logger.out.error(
              `ERROR: atdlParser.parseAlgoDefinition(): Single parameter data parsing exception: %O`,
              ex,
            );
            return null;
          }
        } else {
          logger.out.warn(
            `WARNING: atdlParser.parseAlgoDefinition(): No parameters for for algo ${model.name}`,
            parametersData,
          );
          return null;
        }
        /*********************/
        /* LAYOUT */
        model.layouts = new Array<ATDLInterfaceLayoutModel>();
        model.controls = new Array<ATDLInterfaceControlModel>();
        if (
          sourceData.hasOwnProperty("lay:StrategyLayout") &&
          sourceData["lay:StrategyLayout"].hasOwnProperty("lay:StrategyPanel")
        ) {
          let layoutData: any = sourceData["lay:StrategyLayout"]["lay:StrategyPanel"];
          if (layoutData != null && layoutData.hasOwnProperty("$")) {
            try {
              this.parseLayout(layoutData, model.layouts, model.controls);
            } catch (ex) {
              logger.out.error(
                `ERROR: atdlParser.parseAlgoDefinition(): Layout -> Parsing exception: %O`,
                ex,
              );
              return null;
            }
          } else {
            logger.out.warn(
              `WARN: atdlParser.parseAlgoDefinition(): Layout -> No Algo Layout details provided for ${model.name}`,
            );
          }
          /* LAYOUT - Auxiliary controls */
          if (this.tempAuxiliaryControl instanceof Array && this.tempAuxiliaryControl.length > 0) {
            for (let auxiliaryItem of this.tempAuxiliaryControl) {
              try {
                this.processAuxiliaryControl(auxiliaryItem, model.controls);
              } catch (ex) {
                logger.out.error(
                  `ERROR: atdlParser.parseAlgoDefinition(): Layout -> Auxiliary Control parsing exception: %O`,
                  ex,
                );
                return null;
              }
            }
          }
        }
        /*********************/
        /* VALIDATION */
        let validationData: any = sourceData.hasOwnProperty("val:StrategyEdit")
          ? sourceData["val:StrategyEdit"]
          : null;
        model.validation = new Array<ATDLValidationCaseModel>();
        if (validationData != null && validationData.hasOwnProperty("$")) {
          // single case
          try {
            this.parseValidationCase(validationData, model.validation);
          } catch (ex) {
            logger.out.error(
              `ERROR: atdlParser.parseAlgoDefinition(): Validation data parsing exception: %O`,
              ex,
            );
            return null;
          }
        } else if (
          validationData != null &&
          validationData instanceof Array &&
          validationData.length > 0
        ) {
          // multiple cases
          for (let validationCase of validationData) {
            if (validationCase != null && validationCase.hasOwnProperty("$")) {
              try {
                this.parseValidationCase(validationCase, model.validation);
              } catch (ex) {
                logger.out.error(
                  `ERROR: atdlParser.parseAlgoDefinition(): Validation parsing exception: %O`,
                  ex,
                );
                return null;
              }
            } else {
              logger.out.error(
                `ERROR: atdlParser.parseAlgoDefinition(): Validation data invalid source data on one of multi case.`,
              );
              return null;
            }
          }
        } else if (validationData != null) {
          logger.out.error(
            `ERROR: atdlParser.parseAlgoDefinition(): Validation data structure INVALID %O`,
            validationData,
          );
          return null;
        }
        /*********************/
        /* PARSING COMPLETE  */
        return model; // success
      } else {
        logger.out.error(
          `ERROR: atdlParser.parseAlgoDefinition(): Source data INVALID: %O`,
          sourceData,
        );
        return null;
      }
    } else {
      logger.out.error(`ERROR: atdlParser.parseAlgoDefinition(): Definition is NULL!`);
      return null;
    }
  }

  /**********************************************************************/
  /* PARSING - PARAMETERS */

  private parseParameters(data: any, model: Array<ATDLParameterDataModel>): void {
    if (data != null && data instanceof Array && data.length > 0) {
      for (let paramItem of data) {
        if (
          data != null &&
          paramItem.hasOwnProperty("$") &&
          paramItem.$.hasOwnProperty("name") &&
          paramItem.$.name.length > 0
        ) {
          let paramModel: ATDLParameterDataModel = new ATDLParameterDataModel(paramItem.$.name);
          paramModel.paramType =
            typeof paramItem.$["xsi:type"] === "string"
              ? this.atdlUtility.convertXSITypeToParameterType(paramItem.$["xsi:type"])
              : null;
          paramModel.constValue = paramItem.$.constValue != null ? paramItem.$.constValue : null;
          paramModel.use = paramItem.$.use != null ? paramItem.$.use : null;
          paramModel.required =
            typeof paramModel.use === "string" ? paramModel.use === "required" : false;
          paramModel.minLength =
            paramItem.$.minLength != null && !isNaN(paramItem.$.minLength)
              ? Number(paramItem.$.minLength)
              : null;
          paramModel.maxLength =
            paramItem.$.maxLength != null && !isNaN(paramItem.$.maxLength)
              ? Number(paramItem.$.maxLength)
              : null;
          paramModel.minValue =
            paramItem.$.minValue != null
              ? !isNaN(paramItem.$.minValue)
                ? Number(paramItem.$.minValue)
                : paramItem.$.minValue
              : null;
          if (
            paramModel.refName.toLowerCase() === "limitprice" &&
            (paramModel.minValue == null || paramModel.minValue == 0)
          ) {
            paramModel.minValue = 1e-10;
            logger.out.info(
              `atdlParser.parseParameters(): adjusting c_LimitPrice minValue to ${paramModel.minValue.toFixed(
                10,
              )}`,
            );
          }
          paramModel.maxValue =
            paramItem.$.maxValue != null
              ? !isNaN(paramItem.$.maxValue)
                ? Number(paramItem.$.maxValue)
                : paramItem.$.maxValue
              : null;
          paramModel.precision =
            paramItem.$.precision != null && !isNaN(paramItem.$.precision)
              ? Number(paramItem.$.precision)
              : null;
          // bfx property (not in ATDL specs)
          paramModel.disableOnPartFill =
            typeof paramItem.$.disableOnPartFill === "string"
              ? paramItem.$.disableOnPartFill.toLowerCase() === "true"
              : false;
          // boolean special fields
          paramModel.trueWireValue =
            typeof paramItem.$.trueWireValue === "string" ? paramItem.$.trueWireValue : null;
          paramModel.falseWireValue =
            typeof paramItem.$.falseWireValue === "string" ? paramItem.$.falseWireValue : null;
          // just warning notification when attached to type other than boolean
          if (
            (paramModel.trueWireValue != null || paramModel.falseWireValue != null) &&
            paramModel.paramType !== ATDLNParameterType.BOOLEAN_FIX
          ) {
            logger.out.warn(
              `WARNING: atdlParser.parseParameters(): true or false wire values present on type other than BOOLEAN_FIX`,
            );
          }
          // DEPRECATED (multiplyBy100)
          /* // percentage special field 
					paramModel.multiplyBy100 = typeof paramItem.$.multiplyBy100 === 'string' ? paramItem.$.multiplyBy100 === 'Y' : null;
					// just warning notification when attached to type other than boolean 
					if(paramModel.multiplyBy100 && paramModel.paramType !== ATDLNParameterType.PERCENT){
						logger.out.error(`WARNING: atdlParser.parseParameters(): multiplyBy100 value present on type other than PERCENT`);
					} */

          // PARAMETER Enum
          if (paramItem.EnumPair != null) {
            paramModel.dataset = [];
            // Closure to add XM EnumPair instance to dataset array
            const addEnum = (enumSource) => {
              try {
                let enumItem: ATDLEnumModel = new ATDLEnumModel(
                  enumSource.$.enumID,
                  enumSource.$.wireValue,
                );
                paramModel.dataset.push(enumItem);
              } catch (ex) {
                logger.out.error(
                  `ERROR: atdlParser.parseParameters(): Param Enum parsing exception: ${ex}`,
                );
                throw ex;
              }
            };
            if (paramItem.EnumPair instanceof Array && paramItem.EnumPair.length > 0) {
              for (let enumSource of paramItem.EnumPair) {
                addEnum(enumSource);
              }
            } else {
              // As explicitArray is set to false, there will be no array if only one EnumPair value is specified
              addEnum(paramItem.EnumPair);
            }
          }

          model.push(paramModel); // success
        } else {
          logger.out.error(`ERROR: atdlParser.parseParameters(): Paramter Item source INVALID`);
          throw new Error(`Parameter data source is INVALID`);
        }
      }
    } else {
      throw new Error(`Parameters data source is INVALID`);
    }
  }

  /**********************************************************************/
  /* PARSING - LAYOUT */

  private parseLayout(
    data: any,
    model: Array<ATDLInterfaceLayoutModel>,
    controls: Array<ATDLInterfaceControlModel>,
  ): void {
    try {
      if (data != null && data.hasOwnProperty("$") && data.$.hasOwnProperty("orientation")) {
        let layoutModel: ATDLInterfaceLayoutModel = new ATDLInterfaceLayoutModel();
        layoutModel.collapsible = data.$.collapsible === "true";
        layoutModel.orientation =
          data.$.orientation.toUpperCase() === "HORIZONTAL"
            ? ATDLNOrientation.HORIZONTAL
            : ATDLNOrientation.VERTICAL;

        // INTERFACE CONTROLS
        if (data.hasOwnProperty("lay:Control")) {
          layoutModel.controls = new Array<string>();
          if (data["lay:Control"].hasOwnProperty("$")) {
            // single control
            this.parseLayoutControls(data["lay:Control"], layoutModel.controls, controls);
          } else if (data["lay:Control"] instanceof Array && data["lay:Control"].length > 0) {
            // multiple controls
            for (let controlItem of data["lay:Control"]) {
              this.parseLayoutControls(controlItem, layoutModel.controls, controls);
            }
          } else {
            // error
            logger.out.error(
              `ERROR: atdlParser.parseLayoutData(): Layout Controls -> Source data INVALID %O`,
              data["lay:Control"],
            );
            throw new Error(`Layout Controls data source is INVALID`);
          }
        }

        // INNER PANEL
        if (data.hasOwnProperty("lay:StrategyPanel")) {
          layoutModel.layouts = new Array<ATDLInterfaceLayoutModel>();
          if (data["lay:StrategyPanel"].hasOwnProperty("$")) {
            // single panel
            this.parseLayout(data["lay:StrategyPanel"], layoutModel.layouts, controls);
          } else if (
            data["lay:StrategyPanel"] instanceof Array &&
            data["lay:StrategyPanel"].length > 0
          ) {
            // multiple panels
            for (let layoutData of data["lay:StrategyPanel"]) {
              this.parseLayout(layoutData, layoutModel.layouts, controls);
            }
          } else {
            // error
            logger.out.error(
              `ERROR: atdlParser.parseLayoutData(): Layout Panel -> Source data INVALID %O`,
              data["lay:StrategyPanel"],
            );
            throw new Error(`Layout data source is INVALID`);
          }
        }

        if (layoutModel.layouts != null || layoutModel.controls != null) {
          model.push(layoutModel);
        } else {
          logger.out.error(
            `ERROR: atdlParser.parseLayoutData(): Layout -> Source structure INVALID since there are no controls or inner panels %O`,
            data,
          );
          throw new Error(`Layout data source is INVALID -> No controls or inner panels`);
        }
      } else {
        throw new Error(`Layout data source is INVALID`);
      }
    } catch (ex) {
      throw ex;
    }
  }

  private parseLayoutControls(
    data: any,
    model: Array<string>,
    controls: Array<ATDLInterfaceControlModel>,
  ): void {
    try {
      if (
        (data != null &&
          data.hasOwnProperty("$") &&
          data.$.hasOwnProperty("ID") &&
          data.$.hasOwnProperty("parameterRef")) ||
        !this.isAuxiliaryControl(data)
      ) {
        let controlModel: ATDLInterfaceControlModel;
        if (
          data.$.hasOwnProperty("parameterRef") &&
          typeof data.$.parameterRef === "string" &&
          data.$.parameterRef != ""
        ) {
          controlModel = new ATDLInterfaceControlModel(data.$.ID, data.$.parameterRef);
        } else {
          controlModel = new ATDLInterfaceControlModel(data.$.ID, null);
        }
        controlModel.initValue = data.$.initValue != null ? data.$.initValue : null;
        controlModel.defaultValue = data.$.defaultValue != null ? data.$.defaultValue : null;
        controlModel.label = typeof data.$.label === "string" ? data.$.label : null;
        controlModel.icdType = this.atdlUtility.convertStringToControlType(data.$["xsi:type"]);
        controlModel.icdTypeText =
          typeof data.$["xsi:type"] === "string" ? data.$["xsi:type"].replace("lay:", "") : null;
        // bfx property (not in ATDL specs)
        controlModel.disableOnPartFill =
          typeof data.$.disableOnPartFill === "string"
            ? data.$.disableOnPartFill.toLowerCase() === "true"
            : false;
        // not in use, just parsed
        controlModel.tooltip = typeof data.$.tooltip === "string" ? data.$.tooltip : null;
        controlModel.initFixField =
          typeof data.$.initFixField === "string" ? data.$.initFixField : null;
        controlModel.initPolicy = typeof data.$.initPolicy === "string" ? data.$.initPolicy : null;
        controlModel.disableForTemplate =
          typeof data.$.disableForTemplate === "string" ? data.$.disableForTemplate : null;
        // special properties
        if (controlModel.icdType === ATDLNControlType.SINGLE_SPINNER) {
          controlModel.increment = data.$.increment != null ? data.$.increment : null;
          controlModel.incrementPolicy =
            data.$.incrementPolicy != null ? data.$.incrementPolicy : null;
        } else if (controlModel.icdType === ATDLNControlType.CHECKBOX) {
          controlModel.checkedEnumRef =
            data.$.checkedEnumRef != null ? data.$.checkedEnumRef : null;
          controlModel.uncheckedEnumRef =
            data.$.uncheckedEnumRef != null ? data.$.uncheckedEnumRef : null;
        } else if (controlModel.icdType === ATDLNControlType.RADIO_LIST) {
          controlModel.radioGroup = data.$.radioGroup != null ? data.$.radioGroup : null;
        }
        // INTERFACE ENUM
        if (
          data.hasOwnProperty("lay:ListItem") &&
          data["lay:ListItem"] instanceof Array &&
          data["lay:ListItem"].length > 0
        ) {
          controlModel.dataset = new Array<ATDLEnumModel>();

          for (let enumItem of data["lay:ListItem"]) {
            if (
              enumItem != null &&
              enumItem.hasOwnProperty("$") &&
              enumItem.$.hasOwnProperty("enumID") &&
              enumItem.$.hasOwnProperty("uiRep")
            ) {
              let enumModel: ATDLEnumModel = new ATDLEnumModel(
                enumItem.$.enumID,
                null,
                enumItem.$.uiRep,
              );
              controlModel.dataset.push(enumModel);
            } else {
              logger.out.error(
                `ERROR: atdlParser.parseLayoutControls(): Interface Enum -> Source data is INVALID %O`,
                enumItem,
              );
              throw new Error(`Interface Enum source data is INVALID`);
            }
          }
        } else if (data.hasOwnProperty("lay:ListItem")) {
          // provider isnt an array, its a single item
          controlModel.dataset = new Array<ATDLEnumModel>();
          let enumItem = data["lay:ListItem"];
          if (
            enumItem != null &&
            enumItem.hasOwnProperty("$") &&
            enumItem.$.hasOwnProperty("enumID") &&
            enumItem.$.hasOwnProperty("uiRep")
          ) {
            let enumModel: ATDLEnumModel = new ATDLEnumModel(
              enumItem.$.enumID,
              null,
              enumItem.$.uiRep,
            );
            controlModel.dataset.push(enumModel);
          } else {
            logger.out.error(
              `ERROR: atdlParser.parseLayoutControls(): Interface Enum -> Source data is INVALID %O`,
              enumItem,
            );
            throw new Error(`Interface Enum source data is INVALID`);
          }
        }
        // STATE FLOW
        if (data.hasOwnProperty("flow:StateRule")) {
          let stateFlowData = data["flow:StateRule"];
          controlModel.dependencies = new Array<ATDLInterfaceDependencyModel>();
          if (stateFlowData.hasOwnProperty("$") && stateFlowData.hasOwnProperty("val:Edit")) {
            try {
              this.parseLayoutControlStateFlow(data.$.ID, stateFlowData, controlModel.dependencies);
            } catch (ex) {
              logger.out.error(
                `ERROR: atdlParser.parseLayoutControls(): State-flow Item -> Parsing exception: %O`,
                ex,
              );
              throw ex;
            }
          } else if (stateFlowData instanceof Array && stateFlowData.length > 0) {
            for (let stateFlowItem of stateFlowData) {
              try {
                this.parseLayoutControlStateFlow(
                  data.$.ID,
                  stateFlowItem,
                  controlModel.dependencies,
                );
              } catch (ex) {
                logger.out.error(
                  `ERROR: atdlParser.parseLayoutControls(): State-flow Item -> Parsing exception: %O`,
                  ex,
                );
                throw ex;
              }
            }
          } else {
            logger.out.error(
              `ERROR: atdlParser.parseLayoutControls(): State-flow Item ->  Source data is INVALID %O`,
              data["flow:StateRule"],
            );
            controlModel.dependencies = null;
            throw new Error(`State-flow Item source data is INVALID`);
          }
        }

        controls.push(controlModel); // Success
        model.push(controlModel.icdId);
        // independent flow-state control
      } else if (this.isAuxiliaryControl(data)) {
        ///data != null && data.hasOwnProperty('$') && data.$.hasOwnProperty('ID')  && !data.$.hasOwnProperty('parameterRef') && data.hasOwnProperty('flow:StateRule')){ // auxiliary control
        // NOT A NEW CONTROL - But rather an auxiliary control
        this.tempAuxiliaryControl.push(data);
        //logger.out.info(`'-- Auxiliary Control data: %O`, data);
      } else {
        logger.out.error(
          `ERROR: atdlParser.parseLayoutControls(): Interface Control -> Source data INVALID %O`,
          data,
        );
        throw new Error(`Interface Control source data INVALID`);
      }
    } catch (ex) {
      logger.out.error(
        `ERROR: atdlParser.parseLayoutControls(): Interface Control -> Parsing exception: %O`,
        ex,
      );
      throw ex;
    }
  }

  private isAuxiliaryControl(data: any): boolean {
    if (
      data != null &&
      data.hasOwnProperty("$") &&
      data.$.hasOwnProperty("ID") &&
      !data.$.hasOwnProperty("parameterRef")
    ) {
      try {
        let icdType = this.atdlUtility.convertStringToControlType(data.$["xsi:type"]);
        if (icdType === ATDLNControlType.CHECKBOX && data.hasOwnProperty("flow:StateRule")) {
          // only checkbox can be auxiliary
          let stateFlowData = data["flow:StateRule"];
          if (stateFlowData instanceof Array && stateFlowData.length > 0) {
            let refIcdId: string = null;
            let result: boolean = true;
            for (let stateFlowItem of stateFlowData) {
              if (
                stateFlowItem != null &&
                stateFlowItem.hasOwnProperty("val:Edit") &&
                stateFlowItem["val:Edit"].hasOwnProperty("$")
              ) {
                if (refIcdId == null) {
                  refIcdId = stateFlowItem["val:Edit"].$.field;
                } else {
                  result = result && refIcdId === stateFlowItem["val:Edit"].$.field;
                }
              }
            }
            return result;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  private parseLayoutControlStateFlow(
    id: string,
    data: any,
    model: Array<ATDLInterfaceDependencyModel>,
  ): void {
    if (typeof id === "string" && data.hasOwnProperty("$") && data.hasOwnProperty("val:Edit")) {
      let dependencyModel = new ATDLInterfaceDependencyModel(id);
      dependencyModel.action.enabled = data.$.hasOwnProperty("enabled")
        ? data.$.enabled === "true"
        : null;
      dependencyModel.action.visible = data.$.hasOwnProperty("visible")
        ? data.$.visible === "true"
        : null;
      dependencyModel.action.value = data.$.hasOwnProperty("value") ? data.$.value : null;
      if (
        dependencyModel.action.enabled != null ||
        dependencyModel.action.visible != null ||
        dependencyModel.action.value != null
      ) {
        this.parseEditRules(data, dependencyModel);

        // flatten back to old representation for testing
        if (dependencyModel.rules?.length > 0) {
          let baseRule: ATDLValidationRuleModel = dependencyModel.rules[0];
          dependencyModel.singleFieldDependency = baseRule.field;
          dependencyModel.operator = baseRule.operator;
          dependencyModel.value = baseRule.value;
          model.push(dependencyModel);
        } else {
          // MAke sure only a single top-level Group is defined
          if (dependencyModel.logicGroups?.length === 1) {
            model.push(dependencyModel);
          } else {
            logger.out.error("Ignoring unsupported StateRule: " + data.toString());
          }
        }
        model.push(dependencyModel);
      } else {
        logger.out.error(
          `ERROR: atdlParser.parseLayoutControls(): Interface Control State-flow -> Source data INVALID %O`,
          data.$,
        );
        throw new Error(`State-flow source data RULE is INVALID`);
      }
    } else {
      throw new Error(`State-flow data is INVALID`);
    }
  }

  /**********************************************************************/
  /* PARSING - LAYOUT - AUXILIARY CONTROLS*/

  private processAuxiliaryControl(data: any, controls: Array<ATDLInterfaceControlModel>): void {
    if (
      data != null &&
      data.hasOwnProperty("$") &&
      data.$.hasOwnProperty("ID") &&
      !data.$.hasOwnProperty("parameterRef") &&
      data.hasOwnProperty("flow:StateRule")
    ) {
      // supplmentary contol
      // find the main control
      let stateFlowData = data["flow:StateRule"];
      let auxiliaryModel: ATDLInterfaceAuxiliaryModel = null;
      if (
        stateFlowData != null &&
        stateFlowData.hasOwnProperty("val:Edit") &&
        stateFlowData["val:Edit"].hasOwnProperty("$")
      ) {
        // single state rule
        auxiliaryModel = this.parseAuxiliaryModel(data);
      } else if (
        stateFlowData != null &&
        stateFlowData instanceof Array &&
        stateFlowData.length > 0
      ) {
        // multi state rule
        //logger.out.error(`ERROR: atdlParser.processAuxiliaryControl(): Auxiliary Control -> Multiple state-flows - SITUATION NOT HANDLED IN UI %O`, stateFlowData);
        auxiliaryModel = this.parseAuxiliaryModel(data);
      } else {
        logger.out.error(
          `ERROR: atdlParser.processAuxiliaryControl(): Auxiliary Control -> Source state-flow data INVALID %O`,
          stateFlowData,
        );
      }

      /// ATTACH to Interface Control Model
      //let attached = false;
      if (
        auxiliaryModel instanceof ATDLInterfaceAuxiliaryModel &&
        controls instanceof Array &&
        controls.length > 0
      ) {
        let targetControl: ATDLInterfaceControlModel | null = controls.find(
          (item) => item.icdId === auxiliaryModel.refIcdId,
        );
        if (targetControl != null) {
          if (targetControl.auxiliary == null) {
            targetControl.auxiliary = new Array<ATDLInterfaceAuxiliaryModel>();
          }
          targetControl.auxiliary.push(auxiliaryModel);
        } else {
          logger.out.error(
            `ERROR: atdlParser.processAuxiliaryControl(): Auxiliary Control -> Attachment FAIL: Target control not found ${auxiliaryModel.refIcdId}`,
          );
        }
      } else {
        logger.out.error(
          `ERROR: atdlParser.processAuxiliaryControl(): Auxiliary Control -> Attachment FAIL: ${
            auxiliaryModel != null
              ? `Auxiliary model = OK | Layout model = INVALID `
              : "Auxiliary model = NULL"
          }' `,
        );
      }
    } else {
      logger.out.error(
        `ERROR: atdlParser.processAuxiliaryControl(): Auxiliary Control -> Source data INVALID %O`,
        data,
      );
    }
  }

  private parseAuxiliaryModel(data: any): ATDLInterfaceAuxiliaryModel {
    if (data != null && data.hasOwnProperty("flow:StateRule")) {
      let stateFlowData = data["flow:StateRule"];
      if (
        stateFlowData != null &&
        ((stateFlowData.hasOwnProperty("val:Edit") &&
          stateFlowData["val:Edit"].hasOwnProperty("$")) ||
          stateFlowData instanceof Array)
      ) {
        try {
          let auxiliaryModel: ATDLInterfaceAuxiliaryModel = new ATDLInterfaceAuxiliaryModel();
          // Model parsing
          auxiliaryModel.icdId = data.$.ID;
          //auxiliaryModel.textType = data.$['xsi:type'].replace('lay:', '');
          auxiliaryModel.icdType = this.atdlUtility.convertStringToControlType(data.$["xsi:type"]);
          auxiliaryModel.label = data.$.label;
          auxiliaryModel.initValue =
            data.$.initValue === "true" || data.$.initValue === "false"
              ? data.$.initValue === "true"
              : null;

          // State Flow Parsing

          if (
            stateFlowData != null &&
            stateFlowData.hasOwnProperty("val:Edit") &&
            stateFlowData["val:Edit"].hasOwnProperty("$")
          ) {
            // single state rule
            // attach auxiliary model reference
            auxiliaryModel.refIcdId = stateFlowData["val:Edit"].$.field;
            // process the state rule
            auxiliaryModel.dependencies = new Array<ATDLInterfaceDependencyModel>();
            this.parseLayoutControlStateFlow(data.$.ID, stateFlowData, auxiliaryModel.dependencies);
          } else if (
            stateFlowData != null &&
            stateFlowData instanceof Array &&
            stateFlowData.length > 0
          ) {
            // multi state rule
            // attach auxiliary model reference
            auxiliaryModel.refIcdId = stateFlowData[0]["val:Edit"].$.field;
            //
            auxiliaryModel.dependencies = new Array<ATDLInterfaceDependencyModel>();
            for (let stateFlowItem of stateFlowData) {
              if (
                stateFlowItem != null &&
                stateFlowItem.hasOwnProperty("val:Edit") &&
                stateFlowItem["val:Edit"].hasOwnProperty("$")
              ) {
                if (stateFlowItem["val:Edit"].$.field === auxiliaryModel.refIcdId) {
                  this.parseLayoutControlStateFlow(
                    data.$.ID,
                    stateFlowItem,
                    auxiliaryModel.dependencies,
                  );
                } else {
                  logger.out.error(
                    `ERROR: atdlParser.parseAuxiliaryModel(): Auxiliary Control -> Source state-flow ITEM has INVALID Reference '${stateFlowItem["val:Edit"].$.field}' on ${auxiliaryModel.refIcdId}`,
                  );
                }
              } else {
                logger.out.error(
                  `ERROR: atdlParser.parseAuxiliaryModel(): Auxiliary Control -> Source state-flow ITEM INVALID %O`,
                  stateFlowItem,
                );
              }
            }
          } else {
            logger.out.error(
              `ERROR: atdlParser.parseAuxiliaryModel(): Auxiliary Control -> Source state-flow data INVALID %O`,
              stateFlowData,
            );
            return null;
          }

          return auxiliaryModel;
        } catch (ex) {
          logger.out.error(
            `ERROR: atdlParser.parseAuxiliaryControl(): Auxiliary Model Parsing -> Parsing exception %O`,
            ex,
          );
          return null;
        }
        /* }else if(stateFlowData != null && stateFlowData.hasOwnProperty('val:Edit') && stateFlowData['val:Edit'] instanceof Array){
				logger.out.error(`ERROR: atdlParser.parseAuxiliaryControl(): Auxiliary Control -> Multiple dependency rules - SITUATION NOT HANDLED IN UI %O`, stateFlowData['val:Edit'] );
 */
      } else {
        logger.out.error(
          `ERROR: atdlParser.parseAuxiliaryControl(): Auxiliary Model Parsing -> Attachment FAIL: Source dependency-rule data INVALID`,
        );
        return null;
      }
    } else {
      logger.out.error(
        `ERROR: atdlParser.parseAuxiliaryControl(): Auxiliary Model -> Source data INVALID %O`,
        data,
      );
      return null;
    }
  }

  // not needed once the controls pulled out of the layout and were flattened
  /* private attachAuxiliaryToControl(id: string, auxiliaryModel: ATDLInterfaceAuxiliaryModel, model: ATDLInterfaceLayoutModel, attached: boolean): boolean {
		if(typeof id === 'string' && auxiliaryModel instanceof ATDLInterfaceAuxiliaryModel && model instanceof ATDLInterfaceLayoutModel){// Array && model.length > 0){

			// traverse controls if any
			if(!attached && model.controls instanceof Array && model.controls.length > 0){
				let targetControl: ATDLInterfaceControlModel | null = model.controls.find(item=> item.icdId === id);
				if(targetControl != null){
					attached = true;
					if(targetControl.auxiliary == null){
						targetControl.auxiliary = new Array<ATDLInterfaceAuxiliaryModel>();
					}
					targetControl.auxiliary.push(auxiliaryModel);
				}			
			}
			// traverse layouts if any 
			if(!attached && model.layouts instanceof Array && model.layouts.length > 0){
				for(let layoutItem of model.layouts){
					if(!attached){
						attached = this.attachAuxiliaryToControl(id, auxiliaryModel, layoutItem, attached);
					}
				}
			}
			return attached;

		}else{
			logger.out.error(`ERROR: atdlParser.attachAuxiliaryToControl(): Invalid parameters`);
		}
	} */

  /**********************************************************************/
  /* PARSING - VALIDATION */

  private parseValidationCase(data: any, model: Array<ATDLValidationCaseModel>): void {
    if (
      data != null &&
      data.hasOwnProperty("$") &&
      data.$.hasOwnProperty("errorMessage") &&
      data.hasOwnProperty("val:Edit") &&
      data["val:Edit"] != null
    ) {
      let caseModel: ATDLValidationCaseModel = new ATDLValidationCaseModel(data.$.errorMessage);
      this.parseEditRules(data, caseModel);
      model.push(caseModel);
    } else {
      throw new Error(`Validation CASE parsing ERROR: Source data is INVALID -> ${data}`);
    }
  }

  /**
   * Parse Edit rules and populate caseModel argument - can be used for both
   * StrategyEdit rules and StateRule rules
   * @param data
   * @param caseModel
   */
  private parseEditRules(
    data: any,
    caseModel: { logicGroups: ATDLValidationGroupModel[]; rules: ATDLValidationRuleModel[] },
  ) {
    let validationData = data["val:Edit"];
    if (Array.isArray(validationData)) {
      // We should throw an error here but might have validation errors in existing algo so just do a stern warning instead
      logger.out.error(
        `ERROR (Stern warning): atdlParser.parseValidationCase(): Validation CASE -> multiple top-level validation elements`,
        data,
      );
    }
    // LOGIC GROUP
    if (validationData.hasOwnProperty("$") && validationData.$.hasOwnProperty("logicOperator")) {
      caseModel.logicGroups = new Array<ATDLValidationGroupModel>();
      try {
        this.parseValidationGroups(validationData, caseModel.logicGroups);
      } catch (ex) {
        throw ex;
      }
      // SINGLE VALIDATION RULE
    } else if (validationData.hasOwnProperty("$") && validationData.$.hasOwnProperty("operator")) {
      caseModel.rules = new Array<ATDLValidationRuleModel>();
      try {
        this.parseValidationRule(validationData, caseModel.rules);
      } catch (ex) {
        throw ex;
      }
      // MULTIPLE VALIDATION  RULES
    } else if (
      validationData instanceof Array &&
      validationData.length > 0 &&
      validationData[0].hasOwnProperty("$") &&
      validationData[0].$.hasOwnProperty("operator")
    ) {
      caseModel.rules = new Array<ATDLValidationRuleModel>();
      for (let ruleItem of validationData) {
        try {
          this.parseValidationRule(ruleItem, caseModel.rules);
        } catch (ex) {
          throw ex;
        }
      }
    } else {
      logger.out.error(
        `ERROR: atdlParser.parseValidationCase(): Validation CASE -> Source structure INVALID since there are no validation groups or rules %O`,
        data,
      );
      throw new Error(
        `Validation CASE parsing ERROR: Source structure INVALID -> No validation groups or rules`,
      );
    }
  }

  private parseValidationGroups(data: any, model: Array<ATDLValidationGroupModel>): void {
    if (
      data != null &&
      data.hasOwnProperty("$") &&
      data.$.hasOwnProperty("logicOperator") &&
      data.hasOwnProperty("val:Edit")
    ) {
      let groupsData = data["val:Edit"];
      let groupModel = new ATDLValidationGroupModel(
        this.atdlUtility.convertStringToATDLNLogicOperator(data.$.logicOperator),
      );
      groupModel.logicOperatorText = data.$.logicOperator;
      // LOGIC GROUP - SINGLE
      if (
        groupsData != null &&
        groupsData.hasOwnProperty("$") &&
        groupsData.$.hasOwnProperty("logicOperator")
      ) {
        groupModel.logicGroups = new Array<ATDLValidationGroupModel>();
        this.parseValidationGroups(groupsData, groupModel.logicGroups);
        // LOGIC GROUP - MULTI
      } else if (
        groupsData instanceof Array &&
        groupsData.length > 0 &&
        groupsData[0].hasOwnProperty("$") &&
        groupsData[0].$.hasOwnProperty("logicOperator")
      ) {
        groupModel.logicGroups = new Array<ATDLValidationGroupModel>();
        for (let item of groupsData) {
          try {
            if (item != null && item.hasOwnProperty("$") && item.$.hasOwnProperty("operator")) {
              // item is a rule not a group (parent group has both rules and groups)
              groupModel.rules =
                groupModel.rules == null ? new Array<ATDLValidationRuleModel>() : groupModel.rules;
              this.parseValidationRule(item, groupModel.rules);
            } else {
              this.parseValidationGroups(item, groupModel.logicGroups);
            }
          } catch (ex) {
            throw ex;
          }
        }
        // VALIDATION RULES - SINGLE
      } else if (
        groupsData != null &&
        groupsData.hasOwnProperty("$") &&
        groupsData.$.hasOwnProperty("operator")
      ) {
        groupModel.rules = new Array<ATDLValidationRuleModel>();
        try {
          this.parseValidationRule(groupsData, groupModel.rules);
        } catch (ex) {
          throw ex;
        }
        // VALIDATION RULES - MULTI
      } else if (
        groupsData instanceof Array &&
        groupsData.length > 0 &&
        groupsData[0].hasOwnProperty("$") &&
        groupsData[0].$.hasOwnProperty("operator")
      ) {
        groupModel.rules = new Array<ATDLValidationRuleModel>();
        for (let ruleItem of groupsData) {
          try {
            if (
              ruleItem != null &&
              ruleItem.hasOwnProperty("$") &&
              ruleItem.$.hasOwnProperty("logicOperator")
            ) {
              // item is a group not a rule (parent group has both rules and groups)
              groupModel.logicGroups =
                groupModel.logicGroups == null
                  ? new Array<ATDLValidationGroupModel>()
                  : groupModel.logicGroups;
              this.parseValidationGroups(ruleItem, groupModel.logicGroups);
            } else {
              groupModel.rules =
                groupModel.rules == null ? new Array<ATDLValidationRuleModel>() : groupModel.rules;
              this.parseValidationRule(ruleItem, groupModel.rules);
            }
          } catch (ex) {
            throw ex;
          }
        }
      }

      if ((groupModel != null && groupModel.rules != null) || groupModel.logicGroups != null) {
        model.push(groupModel);
      } else {
        logger.out.error(
          `ERROR: atdlParser.parseValidationGroups(): Validation GROUP -> Source structure INVALID since there are no validation groups or rules %O`,
          data,
        );
        throw new Error(
          `Validation GROUP parsing ERROR: Source structure INVALID -> No validation groups or rules`,
        );
      }
    } else {
      logger.out.error(
        `ERROR: atdlParser.parseValidationGroups(): Validation GROUP -> Source structure INVALID %O`,
        data,
      );
      throw new Error(`Validation GROUP parsing ERROR: Source structure INVALID -> ${data}`);
    }
  }

  private parseValidationRule(data: any, model: Array<ATDLValidationRuleModel>): void {
    if (
      data != null &&
      data.hasOwnProperty("$") &&
      data.$.hasOwnProperty("field") &&
      data.$.hasOwnProperty("operator")
    ) {
      let ruleModel: ATDLValidationRuleModel = new ATDLValidationRuleModel(
        data.$.field,
        this.atdlUtility.convertStringToATDLNOperator(data.$.operator),
      );
      if (!this.atdlUtility.isSingleParamOperator(data.$.operator)) {
        // second paramter required
        if (data.$.hasOwnProperty("field2")) {
          ruleModel.field2 = data.$.field2;
        } else if (data.$.hasOwnProperty("value")) {
          ruleModel.value = data.$.value;
        } else {
          logger.out.error(
            `ERROR: atdlParser.parseValidationRule(): Validation RULE -> Source data INVALID: missing second field/value %O`,
            data.$,
          );
          ruleModel = null;
          throw new Error(
            `Validation RULE parsing ERROR: Source structure INVALID -> Missing second field/value ${data.$}`,
          );
        }
      }
      if (ruleModel != null) {
        // guard if errors
        model.push(ruleModel);
      }
    } else {
      logger.out.error(
        `ERROR: atdlParser.parseValidationGroups(): Validation RULE -> structure is inconsistent`,
      );
      throw new Error(`Validation RULE parsing ERROR: Source structure INVALID -> ${data}`);
    }
  }

  /**********************************************************************/
  /* DEBUG - HELPER  */

  private outputExtendedLogging(value: string, dump: any = null): void {
    this.oeLogger.outputExtendedLogging(value, dump);
  }
}
